import { lazy } from "react";

const Dashboard = lazy(() => import("../Component/Dashboard/Dashboard"));
const NewsDetails = lazy(() => import("../Component/Dashboard/NewsDetails"));

const dashboardRoutes = [
  { path: "/dashboard", element: <Dashboard />, protected: true },
  { path: "/news-details/:id", element: <NewsDetails />, protected: true },
];

export default dashboardRoutes;
